import { MAX_DECIMAL } from "../../../../common/Configurations/DecimalConfiguration";

export const CLIENT_COVERAGES_VALIDATION_RULES = {
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  commissionRate: {
    isRequiredTrim: {
      value: true,
    },
    valueBetween: {
      value: {
        minimum: 0,
        maximum: 100,
      },
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  markUpRate: {
    isRequiredTrim: {
      value: true,
    },
    valueBetween: {
      value: {
        minimum: 0,
        maximum: 100,
      },
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  clientReserveRate: {
    isRequiredTrim: {
      value: true,
    },
    valueBetween: {
      value: {
        minimum: 0,
        maximum: 100,
      },
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  guaranteeId: {
    isRequiredTrim: {
      value: true,
    },
  },
  insurerId: {
    isRequiredTrim: {
      value: true,
    },
  },
  administrator: {
    isRequiredTrim: {
      value: true,
    },
  },
  ageOfPolicyExpiration: {
    isRequiredTrim: {
      value: true,
    },
  },
  ageOfPolicyDecrease: {
    isRequiredTrim: {
      value: true,
    },
  },
  percentageOfPolicyDecrease: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  taxType: {
    isRequiredTrim: {
      value: true,
    },
  },
  tpaTaxType: {
    isRequiredTrim: {
      value: true,
    },
  },
  fixedRate: {
    isRequiredTrim: {
      value: true,
    },
  },
  priceListRate: {
    isRequiredTrim: {
      value: true,
    },
  },
  formulaType: {
    isRequiredTrim: {
      value: true,
    },
  },
  formulaRate: {
    isRequiredTrim: {
      value: true,
    },
  },
  formula: {
    isRequiredTrim: {
      value: true,
    },
  },
  formulaVolume: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  volumeCalculation: {
    isRequiredTrim: {
      value: true,
    },
  },
  rate: {
    isRequiredTrim: {
      value: true,
    },
  },
  fixed: {
    isRequiredTrim: {
      value: true,
    },
  },
  perAnnualSalary: {
    isRequiredTrim: {
      value: true,
    },
  },
  defaultInvoicedClientRateCouple: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultInvoicedClientRateFamily: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultInvoicedClientRateSingle: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultInvoicedClientRateSingleParent: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultInvoicedClientRateWaived: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultClientRateCouple: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultClientRateFamily: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultClientRateSingle: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultClientRateSingleParent: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultClientRateWaived: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultProviderRateCouple: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultProviderRateFamily: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultProviderRateSingle: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultProviderRateSingleParent: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultProviderRateWaived: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultTpaFeeCouple: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultTpaFeeFamily: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultTpaFeeSingle: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultTpaFeeSingleParent: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultTpaFeeWaived: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultGapFeeCouple: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultGapFeeFamily: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultGapFeeSingle: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultGapFeeSingleParent: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  defaultGapFeeWaived: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  prices: {
    array: {
      invoicedClientRate: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
        isRequiredTrim: {
          value: true,
        },
      },
      clientRate: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
        isRequiredTrim: {
          value: true,
        },
      },
      tpaFee: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
        isRequiredTrim: {
          value: true,
        },
      },
      gapFee: {
        float: {
          value: {
            decimals: MAX_DECIMAL,
          },
        },
        isRequiredTrim: {
          value: true,
        },
      },
    },
  },
  invoicedClientRate: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  clientRate: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
    isRequiredTrim: {
      value: true,
    },
  },
  formulaSalaryDenominator: {
    isRequiredTrim: {
      value: true,
    },
  },
  formulaPart: {
    isRequiredTrim: {
      value: true,
    },
  },
  formulaPart1: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  formulaPart2: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  formulaPart3: {
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  formulaMultiple1: {
    isRequiredTrimIfField: {
      value: {
        field: "formulaPart1",
      },
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  formulaMultiple2: {
    isRequiredTrimIfField: {
      value: {
        field: "formulaPart2",
      },
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  formulaMultiple3: {
    isRequiredTrimIfField: {
      value: {
        field: "formulaPart3",
      },
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  formulaRoundedNumber: {
    isRequiredTrim: {
      value: true,
    },
  },
  formulaMaximum: {
    isRequiredTrim: {
      value: true,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  formulaMspa: {
    isRequiredTrim: {
      value: true,
    },
    float: {
      value: {
        decimals: MAX_DECIMAL,
      },
    },
  },
  class: {
    isRequiredTrim: {
      value: true,
    },
  },
  coverage: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/clientCoveragesValidationRules.js